import React, { useState } from 'react';
import {
    Cards,
    Box,
    SpaceBetween,
    Header,
} from '@amzn/awsui-components-console';
import { BulkEntityValidationRecord } from 'src/components/selfServeWorkflows/requirementsPortal/bulkUploadSteps/BulkExecutionStepProgress';
import { WorkflowDefinition } from '@amzn/snow-nxt-workflow-service-typescript-client';
import { logger } from 'src/utils/logger';

interface BulkExecutionReviewStepProps {
    list: BulkEntityValidationRecord[];
    workflowDefinition: WorkflowDefinition | undefined;
    bulkExecutionId?: string;
}

const BulkExecutionReviewStep: React.FC<BulkExecutionReviewStepProps> = (props) => {
    const [selectedItems, setSelectedItems] = useState<BulkEntityValidationRecord[]>([]);

    const ensureMap = (input: any): Map<string, string> => {
        if (input instanceof Map) {
            return input;
        }

        if (typeof input === 'object' && input !== null) {
            return new Map(Object.entries(input));
        }

        logger.error('Invalid recordJsonString format: Expected Map or object', input);
        return new Map();
    };

    return (
        <Cards
            cardDefinition={{
                header: (item) => <Header variant="h3">{item.entityId}</Header>,
                sections: [
                    {
                        id: 'attributes',
                        header: 'Attributes',
                        content: (item) => {
                            const mapData = ensureMap(item.inputRecord);

                            return (
                                <Box padding={{ vertical: 's' }}>
                                    {Array.from(mapData.entries()).map(([key, value], idx) => (
                                        <Box key={idx} padding={{ vertical: 'xs' }}>
                                            <Box fontWeight="bold">{key}</Box>
                                            <Box>{key === 'value' ? atob(value) : String(value)}</Box>
                                        </Box>
                                    ))}
                                </Box>
                            );
                        },
                    },
                ],
            }}
            items={props.list}
            ariaLabels={{
                itemSelectionLabel: (item, selected) => `Select record ${item}`,
                selectionGroupLabel: 'Record selection',
            }}
            selectedItems={selectedItems}
            onSelectionChange={({ detail }) => setSelectedItems(detail.selectedItems)}
            cardsPerRow={[
                { cards: 1 },
                { minWidth: 500, cards: 2 },
            ]}
            empty={
                <Box margin={{ vertical: 'xs' }} textAlign="center" color="inherit">
                    <SpaceBetween size="m">
                        <b>No records found</b>
                    </SpaceBetween>
                </Box>
            }
            header={
                <>
                    <Header>Records for Workflow: {props.workflowDefinition?.workflowDefinitionName}</Header>
                    <h3>Execution ID: {props.bulkExecutionId}</h3>
                </>
            }
        />
    );
};

export default BulkExecutionReviewStep;
